const ValeTemplates = [
  {
    id: 0,
    title: "CUIA (Central das Cooperativas de Produção Familiar da Região Amazônica)",
    message:
      "A Vale, em parceria com a CUIA (Central das Cooperativas de Produção Familiar da Região Amazônica), oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 1,
    title: "Município de Canaã dos Carajás",
    message:
      "A Vale, em parceria com o município de Canaã dos Carajás, oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 2,
    title: "Município de Curionópolis",
    message:
      "A Vale, em parceria com o município de Curionópolis, oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 3,
    title: "Município de Ourilândia do Norte",
    message:
      "A Vale, em parceria com o município de Ourilândia do Norte, oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 4,
    title: "Município de Parauapebas",
    message:
      "A Vale, em parceria com o município de Parauapebas, oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 5,
    title: "Município de Marabá",
    message:
      "A Vale, em parceria com o município de Marabá, oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 6,
    title: "Município de Bom Jesus do Tocantins",
    message:
      "A Vale, em parceria com o município de Bom Jesus do Tocantins, oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 7,
    title: "Município de Tucumã",
    message:
      "A Vale, em parceria com o município de Tucumã, oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 8,
    title: "Município de Eldorado dos Carajás",
    message:
      "A Vale, em parceria com o município de Eldorado dos Carajás, oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 9,
    title: "Município de São Félix do Xingu",
    message:
      "A Vale, em parceria com o município de São Félix do Xingu, oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 10,
    title: "Município de Redenção",
    message:
      "A Vale, em parceria com o município de Redenção, oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 11,
    title: "Município de Floresta do Araguaia",
    message:
      "A Vale, em parceria com o município de Floresta do Araguaia, oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 12,
    title: "Município de Itupiranga",
    message:
      "A Vale, em parceria com o município de Itupiranga, oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 13,
    title: "Município de Nova Ipixuna",
    message:
      "A Vale, em parceria com o município de Nova Ipixuna, oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 15,
    title: "Município de São João do Araguaia",
    message:
      "A Vale, em parceria com o município de São João do Araguaia, oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 16,
    title: "Município de Tailândia",
    message:
      "A Vale, em parceria com o município de Tailândia, oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 25,
    title: "TERMO DE ACEITE: A Vale, em parceria...",
    message:
      "A Vale, em parceria com a CUIA (Central das Cooperativas de Produção Familiar da Região Amazônica), oferece um programa gratuito de assistência técnica e extensão rural aos produtores rurais familiares do município para ajudar a identificar possíveis problemas, encontrar soluções e melhorar a produção no campo. Você aceita participar ativamente do projeto?",
  },
  {
    id: 26,
    title: "Faremos o envio de 04 aulas do 1º curso...",
    message: `Olá, produtor (a)! Vamos dar início as capacitações do projeto Assistex?

    Faremos o envio de 04 aulas do 1º curso, com práticas para você aumentar sua produtividade e melhorar cada vez mais sua produção! Ao final das 04 aulas você receberá um certificado de participação no curso! 
    
    Me avisa quando você já tiver assistido a primeira aula!`,
  },
  {
    id: 27,
    title: "Qual o nome da sua comunidade?",
    message: `Olá, produtor! Aqui quem fala é o Bento do projeto ASSISTEX! 
    Qual o nome da sua comunidade?`,
  },
]

const LaborTemplates = [
  //   {
  //     id: 0,
  //     title: "Mensagem de Apresentação",
  //     message: `Prezado(a) produtor(a), tudo bem?

  // 🤝 Somos da equipe do projeto Campo Futuro Aves e Suínos, desenvolvido pela CNA (Confederação da Agricultura e Pecuária do Brasil), em parceria com a Labor Rural.

  // 📊 Gostaríamos de convidá-lo(a) a compartilhar informações importantes que irão enriquecer análises e apoiar decisões estratégicas, fortalecendo o setor.
  // 🎖️ Como participante, você terá acesso exclusivo a conteúdos mensais de alto valor.
  // 👇 Confira nosso vídeo institucional e conheça nosso propósito:
  // {{1}}

  // Se você deseja fazer parte do projeto, responda o chat com um "Sim". Se não tem interesse, responda com "Não".

  // Obrigado pela parceria!`,
  //   },
  {
    id: 2,
    title: "Mensagem de Coleta",
    message: `Prezado(a) produtor(a), tudo bem?
👇 Como parceiro(a) no projeto Campo Futuro Aves e Suínos, convidamos você a dedicar alguns minutos para responder ao levantamento mensal de insumos abaixo:
{{1}}`,
  },
  {
    id: 3,
    title: "Boas vindas+aceite com coleta",
    message: `🌱 Olá, produtor(a)! Tudo bem?
 
Somos da equipe do Projeto Campo Futuro Aves e Suínos, uma iniciativa da CNA, em parceria com a Labor Rural, que busca fortalecer o setor com informações estratégicas e relevantes.
 
Gostaríamos de contar com você! Sua participação é essencial para construir análises mais precisas e apoiar decisões que impactam diretamente a rentabilidade e sustentabilidade da atividade.
 
🚀 Vantagens para você:
✅ Acesso exclusivo a conteúdos mensais valiosos
✅ Informações atualizadas para melhorar sua gestão
✅ Contribuição direta para o desenvolvimento do setor
 
Quer fazer parte desse movimento?
 
Se sim, poderia dedicar alguns instantes para responder ao nosso levantamento mensal de insumos?
 
📌 Acesse aqui para responder:
 
{{1}}
 
Agradecemos sua parceria! 🐖🐓`,
  },
  {
    id: 4,
    title: "Mensagem de coleta 2",
    message: `🌱 Olá, produtor(a)!

Sua participação no Projeto Campo Futuro é essencial para mensurarmos os custos de produção de aves e suínos.

📊 Responda ao levantamento mensal de insumos e contribua!  

📌 Acesse aqui:

{{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 5,
    title: "Mensagem de coleta 3",
    message: `🌱 Olá, Produtor(a)!
 
Esperamos que esteja bem! Notamos que ainda não respondeu as perguntas do link enviado anteriormente. Para garantir que todas as informações sejam devidamente registradas, pedimos que preencha o link abaixo:
 
{{1}}
 
Isso ajudará entendermos melhor o setor e buscarmos melhorias que beneficiem a todos! 🚀
 
Caso tenha alguma dúvida ou necessite de auxílio, estamos à disposição para ajudar.
 
Agradecemos sua atenção e colaboração! 🐖🐓`,
  },
  {
    id: 6,
    title: "Mensagem Suinocultura 2",
    message: `Que bom falar com você, {{name}}! 👋

Estamos fazendo uma pesquisa mensal com produtores para entender melhor como estão os custos e os ganhos da SUINOCULTURA no Brasil.

A sua experiência como SUINOCULTOR pode fazer toda a diferença para levantar informações reais! Você consegue nos ajudar?

Se puder dedicar uns 3 minutinhos para isso, ficaríamos muito gratos:

{{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 7,
    title: "Mensagem Avicultura 2",
    message: `Que bom falar com você, {{name}}! 👋

Estamos fazendo uma pesquisa mensal com produtores para entender melhor como estão os custos e os ganhos da AVICULTURA no Brasil.

A sua experiência como AVICULTOR pode fazer toda a diferença para levantar informações reais! Você consegue nos ajudar?

Se puder dedicar uns 3 minutinhos para isso, ficaríamos muito gratos:

{{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 8,
    title: "Mensagem Suinocultura 3",
    message: `Estamos fazendo uma pesquisa mensal com produtores para entender melhor como estão os custos e os ganhos da SUINOCULTURA no Brasil.

A sua experiência como SUINOCULTOR pode fazer toda a diferença para levantar informações reais! Você consegue nos ajudar?

Se puder dedicar uns 3 minutinhos para isso, ficaríamos muito gratos:

{{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 9,
    title: "Mensagem Avicultura 3",
    message: `Estamos fazendo uma pesquisa mensal com produtores para entender melhor como estão os custos e os ganhos da AVICULTURA no Brasil.

A sua experiência como AVICULTOR pode fazer toda a diferença para levantar informações reais! Você consegue nos ajudar?

Se puder dedicar uns 3 minutinhos para isso, ficaríamos muito gratos:

{{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 10,
    title: "Mensagem Suinocultura 5",
    message: `Só passando para lembrar que ainda estamos aguardando sua resposta na pesquisa sobre a produção de SUINOCULTURA.

Imaginamos que esteja na correria do dia a dia.

Quando você conseguir participar, vamos te enviar gratuitamente um conteúdo com certificado sobre Gestão Econômica, feito para ajudar produtores como você na gestão da produção.

Responda aqui (leva só 3 min): {{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 11,
    title: "Mensagem Avicultura 5",
    message: `Só passando para lembrar que ainda estamos aguardando sua resposta na pesquisa sobre a produção de AVICULTURA.

Imaginamos que esteja na correria do dia a dia.

Quando você conseguir participar, vamos te enviar gratuitamente um conteúdo com certificado sobre Gestão Econômica, feito para ajudar produtores como você na gestão da produção.

Responda aqui (leva só 3 min): {{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 12,
    title: "Mensagem Suinocultura 6",
    message: `Boa tarde {{name}}, tudo bem?

Equipe do Campo Futuro aqui novamente. Obrigada por ter interagido conosco recentemente!

Já liberei o formulário do último mês! Se puder dedicar uns minutinhos de novo, vai nos ajudar demais a acompanhar a evolução da produção de SUINOCULTURA no Brasil.

Responda aqui (é rapidinho): {{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 13,
    title: "Mensagem Avicultura 6",
    message: `Boa tarde {{name}}, tudo bem?

Equipe do Campo Futuro aqui novamente. Obrigada por ter interagido conosco recentemente!

Já liberei o formulário do último mês! Se puder dedicar uns minutinhos de novo, vai nos ajudar demais a acompanhar a evolução da produção de AVICULTURA no Brasil.

Responda aqui (é rapidinho): {{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 14,
    title: "Mensagem Padrão 7",
    message: `Oi {{name}}!

Só passando para lembrar que sua resposta do último ainda não chegou. Imagino que esteja na correria.

Assim que você responder, vamos te enviar um novo conteúdo gratuito com certificado sobre Gestão Econômica, como forma de agradecimento 😊

Link para responder (leva só 3 minutos): {{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 15,
    title: "Mensagem Suinocultura 8",
    message: `Oi {{name}}, essa é a última chamada para responder o formulário deste!

A sua experiência como SUINOCULTOR pode fazer toda a diferença para levantar informações reais! Você consegue nos ajudar?

Responda aqui antes que a coleta termine: {{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 16,
    title: "Mensagem Avicultura 8",
    message: `Oi {{name}}, essa é a última chamada para responder o formulário deste!

A sua experiência como AVICULTOR pode fazer toda a diferença para levantar informações reais! Você consegue nos ajudar?

Responda aqui antes que a coleta termine: {{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 17,
    title: "01 - Enviar formulário",
    templateId: "HX8b7b22c5868d0b4525caa076aaa221ce",
    message: `Boa tarde, {{name}}! Tudo certo por aí?

Aqui é a equipe do Campo Futuro novamente 😊 Obrigado por ter participado com a gente na última coleta!

Liberamos o formulário de coleta, se puder dedicar mais alguns minutinhos, sua contribuição será essencial para acompanharmos a evolução da suinocultura e avicultura no Brasil.

👉 Para responder: {{1}}`,
  },
  {
    id: 18,
    title: "03 - Enviar formulário",
    templateId: "HXfb144a36bc154485c50cf0fdf148f892",
    message: `Oi {{name}}!

Passando rapidinho só pra lembrar que ainda não recebemos sua resposta da última coleta.
Sabemos que a rotina é puxada, mas sua participação é super importante e sua vivência no campo é essencial pra entendermos um panorama real da produção.

👉 Responda aqui: {{1}}`,
  },
  {
    id: 19,
    title: "05 - Enviar formulário",
    templateId: "HXd1eb5bbacdb7088bab1faea21abb3890",
    message: `Oi {{name}}!
 
Essa é a última chamada para responder nossa pesquisa mensal. Você consegue nos ajudar?
 
👉 Responda aqui: {{1}}`,
  },
  {
    id: 20,
    title: "07 - Enviar formulário",
    templateId: "HX8a6849adb326463dfeb60d98ca6e0973",
    message: `Oi, {{name}}!

A gente sabe que o dia a dia no campo é corrido, mas sua resposta ainda não chegou por aqui 😅
Ela é muito importante pra mantermos o acompanhamento da atividade atualizado!
Sua vivência no campo é essencial pra entendermos um panorama real da produção.

👉 É rapidinho, só clicar aqui: {{1}}`,
  },
]

const ProjetoManejeBemTemplates = [
  {
    id: 3,
    title: "Boas vindas+aceite com coleta",
    message: `🌱 Olá, produtor(a)! Tudo bem?
 
Somos da equipe do Projeto Campo Futuro Aves e Suínos, uma iniciativa da CNA, em parceria com a Labor Rural, que busca fortalecer o setor com informações estratégicas e relevantes.
 
Gostaríamos de contar com você! Sua participação é essencial para construir análises mais precisas e apoiar decisões que impactam diretamente a rentabilidade e sustentabilidade da atividade.
 
🚀 Vantagens para você:
✅ Acesso exclusivo a conteúdos mensais valiosos
✅ Informações atualizadas para melhorar sua gestão
✅ Contribuição direta para o desenvolvimento do setor
 
Quer fazer parte desse movimento?
 
Se sim, poderia dedicar alguns instantes para responder ao nosso levantamento mensal de insumos?
 
📌 Acesse aqui para responder:
 
{{1}}
 
Agradecemos sua parceria! 🐖🐓`,
  },
  {
    id: 4,
    title: "Mensagem de coleta 2",
    message: `🌱 Olá, produtor(a)!

Sua participação no Projeto Campo Futuro é essencial para mensurarmos os custos de produção de aves e suínos.

📊 Responda ao levantamento mensal de insumos e contribua!  

📌 Acesse aqui:

{{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 5,
    title: "Mensagem de coleta 3",
    message: `🌱 Olá, Produtor(a)!
 
Esperamos que esteja bem! Notamos que ainda não respondeu as perguntas do link enviado anteriormente. Para garantir que todas as informações sejam devidamente registradas, pedimos que preencha o link abaixo:
 
{{1}}
 
Isso ajudará entendermos melhor o setor e buscarmos melhorias que beneficiem a todos! 🚀
 
Caso tenha alguma dúvida ou necessite de auxílio, estamos à disposição para ajudar.
 
Agradecemos sua atenção e colaboração! 🐖🐓`,
  },
  {
    id: 6,
    title: "Mensagem Suinocultura 2",
    message: `Que bom falar com você, {{name}}! 👋

Estamos fazendo uma pesquisa mensal com produtores para entender melhor como estão os custos e os ganhos da SUINOCULTURA no Brasil.

A sua experiência como SUINOCULTOR pode fazer toda a diferença para levantar informações reais! Você consegue nos ajudar?

Se puder dedicar uns 3 minutinhos para isso, ficaríamos muito gratos:

{{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 7,
    title: "Mensagem Avicultura 2",
    message: `Que bom falar com você, {{name}}! 👋

Estamos fazendo uma pesquisa mensal com produtores para entender melhor como estão os custos e os ganhos da AVICULTURA no Brasil.

A sua experiência como AVICULTOR pode fazer toda a diferença para levantar informações reais! Você consegue nos ajudar?

Se puder dedicar uns 3 minutinhos para isso, ficaríamos muito gratos:

{{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 8,
    title: "Mensagem Suinocultura 3",
    message: `Estamos fazendo uma pesquisa mensal com produtores para entender melhor como estão os custos e os ganhos da SUINOCULTURA no Brasil.

A sua experiência como SUINOCULTOR pode fazer toda a diferença para levantar informações reais! Você consegue nos ajudar?

Se puder dedicar uns 3 minutinhos para isso, ficaríamos muito gratos:

{{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 9,
    title: "Mensagem Avicultura 3",
    message: `Estamos fazendo uma pesquisa mensal com produtores para entender melhor como estão os custos e os ganhos da AVICULTURA no Brasil.

A sua experiência como AVICULTOR pode fazer toda a diferença para levantar informações reais! Você consegue nos ajudar?

Se puder dedicar uns 3 minutinhos para isso, ficaríamos muito gratos:

{{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 10,
    title: "Mensagem Suinocultura 5",
    message: `Só passando para lembrar que ainda estamos aguardando sua resposta na pesquisa sobre a produção de SUINOCULTURA.

Imaginamos que esteja na correria do dia a dia.

Quando você conseguir participar, vamos te enviar gratuitamente um conteúdo com certificado sobre Gestão Econômica, feito para ajudar produtores como você na gestão da produção.

Responda aqui (leva só 3 min): {{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 11,
    title: "Mensagem Avicultura 5",
    message: `Só passando para lembrar que ainda estamos aguardando sua resposta na pesquisa sobre a produção de AVICULTURA.

Imaginamos que esteja na correria do dia a dia.

Quando você conseguir participar, vamos te enviar gratuitamente um conteúdo com certificado sobre Gestão Econômica, feito para ajudar produtores como você na gestão da produção.

Responda aqui (leva só 3 min): {{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 12,
    title: "Mensagem Suinocultura 6",
    message: `Boa tarde {{name}}, tudo bem?

Equipe do Campo Futuro aqui novamente. Obrigada por ter interagido conosco recentemente!

Já liberei o formulário do último mês! Se puder dedicar uns minutinhos de novo, vai nos ajudar demais a acompanhar a evolução da produção de SUINOCULTURA no Brasil.

Responda aqui (é rapidinho): {{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 13,
    title: "Mensagem Avicultura 6",
    message: `Boa tarde {{name}}, tudo bem?

Equipe do Campo Futuro aqui novamente. Obrigada por ter interagido conosco recentemente!

Já liberei o formulário do último mês! Se puder dedicar uns minutinhos de novo, vai nos ajudar demais a acompanhar a evolução da produção de AVICULTURA no Brasil.

Responda aqui (é rapidinho): {{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 14,
    title: "Mensagem Padrão 7",
    message: `Oi {{name}}!

Só passando para lembrar que sua resposta do último ainda não chegou. Imagino que esteja na correria.

Assim que você responder, vamos te enviar um novo conteúdo gratuito com certificado sobre Gestão Econômica, como forma de agradecimento 😊

Link para responder (leva só 3 minutos): {{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 15,
    title: "Mensagem Suinocultura 8",
    message: `Oi {{name}}, essa é a última chamada para responder o formulário deste!

A sua experiência como SUINOCULTOR pode fazer toda a diferença para levantar informações reais! Você consegue nos ajudar?

Responda aqui antes que a coleta termine: {{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 16,
    title: "Mensagem Avicultura 8",
    message: `Oi {{name}}, essa é a última chamada para responder o formulário deste!

A sua experiência como AVICULTOR pode fazer toda a diferença para levantar informações reais! Você consegue nos ajudar?

Responda aqui antes que a coleta termine: {{1}}

🚀 Obrigado pela parceria! 🐖🐓`,
  },
  {
    id: 17,
    title: "01 - Enviar formulário",
    templateId: "HX8b7b22c5868d0b4525caa076aaa221ce",
    message: `Boa tarde, {{name}}! Tudo certo por aí?

Aqui é a equipe do Campo Futuro novamente 😊 Obrigado por ter participado com a gente na última coleta!

Liberamos o formulário de coleta, se puder dedicar mais alguns minutinhos, sua contribuição será essencial para acompanharmos a evolução da suinocultura e avicultura no Brasil.

👉 Para responder: {{1}}`,
  },
  {
    id: 18,
    title: "03 - Enviar formulário",
    templateId: "HXfb144a36bc154485c50cf0fdf148f892",
    message: `Oi {{name}}!

Passando rapidinho só pra lembrar que ainda não recebemos sua resposta da última coleta.
Sabemos que a rotina é puxada, mas sua participação é super importante e sua vivência no campo é essencial pra entendermos um panorama real da produção.

👉 Responda aqui: {{1}}`,
  },
  {
    id: 19,
    title: "05 - Enviar formulário",
    templateId: "HXd1eb5bbacdb7088bab1faea21abb3890",
    message: `Oi {{name}}!
 
Essa é a última chamada para responder nossa pesquisa mensal. Você consegue nos ajudar?
 
👉 Responda aqui: {{1}}`,
  },
  {
    id: 20,
    title: "07 - Enviar formulário",
    templateId: "HX8a6849adb326463dfeb60d98ca6e0973",
    message: `Oi, {{name}}!

A gente sabe que o dia a dia no campo é corrido, mas sua resposta ainda não chegou por aqui 😅
Ela é muito importante pra mantermos o acompanhamento da atividade atualizado!
Sua vivência no campo é essencial pra entendermos um panorama real da produção.

👉 É rapidinho, só clicar aqui: {{1}}`,
  },
  {
    id: 21,
    title: "1 - Template Soy ADM",
    templateId: "HXc2a9679db9b39d9f892bd0ff39f167c0",
    message: `Olá, {{name}}! Tudo bem ?

Estou encaminhando o formulário para ser preenchido para a participação da certificação Responsible Soy - ADM. 

Qualquer dúvida não existe em me chamar. 

Para responder o formulário basta clicar aqui 👉 {{1}}`,
  },
]

const ProjetoSoy = [
  {
    id: 1,
    title: "1 - Template",
    templateId: "HXc2a9679db9b39d9f892bd0ff39f167c0",
    message: `Olá, {{name}}! Tudo bem ?

Estou encaminhando o formulário para ser preenchido para a participação da certificação Responsible Soy - ADM. 

Qualquer dúvida não existe em me chamar. 

Para responder o formulário basta clicar aqui 👉 {{1}}`,
  },
]

const ProjetoMSD = [
  {
    id: 1,
    title: "Coleta MSD",
    templateId: "HXa07fa3a790226e5bdbf5dc952f44b1fd",
    message: `Bom tarde, {{name}}! Tudo bom ?
To precisando de uma ajuda sua, preciso de algumas informações sobre a produção. Vou mandar um link para responder umas perguntas rápidas.
Para responder as perguntas basta clicar no Link 👉 {{1}}`,
  }
]

const ProjetoCoopatec = [
  {
    id: 1,
    title: "Coleta",
    templateId: "HX91885470cbf54b40a779d9a693a22f90",
    message: `Bom dia, {{name}}!

A Coopaflora e a ManejeBem estão juntando forças pra melhorar ainda mais a vida no campo. Precisamos que você responda algumas perguntas bem simples pra entender melhor como está sua realidade e o que você está precisando.

Contamos com sua participação!
 
👉 É só clicar aqui e responder: {{1}}`,
  }
]

const termsList = {
  // Tech test
  ["dc4096b3-d97b-4c7c-8d0a-5e3745b069d2"]: ValeTemplates,
  // Fitocon
  ["da91285f-c7d8-4202-89f9-70967b726907"]: ValeTemplates,

  ["808363a9-77f6-41a0-9ce2-8696bba67846"]: ValeTemplates,
  ["af22bc32-e31e-44be-b910-8f5925f97753"]: ValeTemplates,
  ["fbc5eddf-4c1f-4235-8351-6f08c8868d07"]: ValeTemplates,
  ["e399728a-523e-4f5c-bdbe-93b3c0247592"]: ValeTemplates,
  ["df948717-c0cf-41da-b8d1-339db95f391c"]: ValeTemplates,
  ["5b115427-65b1-43f9-a170-87907697fb67"]: ValeTemplates,
  ["6f540aff-94b0-4307-95a8-8664bad2e2cf"]: ValeTemplates,
  ["6229706d-b5d5-4b90-a537-34fb90bc7117"]: ValeTemplates,
  ["efeddb69-1e9f-4dae-b102-bf1f2de21003"]: ValeTemplates,
  ["edcb68a4-c17d-4e65-b63f-132175bba118"]: ValeTemplates,
  ["2097789a-9a2f-4ae0-a346-26eb2da0e055"]: ValeTemplates,
  ["5ad00946-d439-4ad5-8754-fe1a6aa6cfd6"]: ValeTemplates,
  ["a5ead5e3-48e2-4a15-94dd-395158c18baf"]: ValeTemplates,
  ["2072ed4d-526e-4f8a-b549-ff67ebccad18"]: ValeTemplates,
  ["3bc67f9b-1aa0-486a-9224-7dda6aea3d56"]: ValeTemplates,
  ["d2f008f1-5ef8-4caf-9871-c3ba5e6e3a8b"]: ValeTemplates,
  ["b4fce4ea-47d2-4fc8-92b2-5637617f4b4d"]: ValeTemplates,
  ["dd532b8b-012e-4f77-a9d7-a0a8d7d92804"]: ValeTemplates,
  ["cd192c5d-dcfd-416f-9e64-97ba77ae4cf0"]: ValeTemplates,
  ["e59a90f3-bbd7-4a65-a9dc-bdf54bfdced9"]: ValeTemplates,
  ["25ccd95b-5b6d-41d7-9010-d2c9d0f7480e"]: ValeTemplates,
  ["49f4b29d-b64d-4c50-bbab-fa9f794b2928"]: ValeTemplates,
  ["6a7e2c29-5a14-4422-a454-b8ce7873e82b"]: ValeTemplates,
  ["1f0a8635-cdcc-4271-aa21-72cb00186c1e"]: ValeTemplates,
  ["f422d319-6bcb-4b22-86c4-8808d24875e6"]: ValeTemplates,
  ["ab47e189-5173-48bf-9304-7c998a122127"]: ValeTemplates,
  ["4700d19e-205f-4653-b013-bca713c75267"]: ValeTemplates,
  ["808363a9-77f6-41a0-9ce2-8696bba67846"]: ValeTemplates,
  ["cec9fa16-2b9a-49a3-9e22-f6173ebf8f27"]: ValeTemplates,
  ["4f21a935-dad1-4a84-87c1-ce8b553fe8d3"]: ValeTemplates,
  ["5ab821cb-0e09-4187-861a-9d5db9a18bfd"]: ValeTemplates,
  ["ffc83652-6023-4020-82f6-3031100c77d7"]: ValeTemplates,
  ["83ccd885-4892-4933-b568-84b7b01bb89d"]: ValeTemplates,
  ["5a9398bb-1381-4d85-a3ab-9cde789626c9"]: ValeTemplates,
  ["a89f1a96-f023-4a91-a7b5-6ce2ba717ccd"]: ValeTemplates,
  ["1cab5e4d-91a0-4cff-84c0-8c237084b1ec"]: ValeTemplates,
  ["e114aed1-770d-4b5e-9c8d-684b4287575d"]: ValeTemplates,
  ["fd528541-2e21-4852-9dc6-fc4737ce5414"]: ValeTemplates,

  //LABOR
  ["cbc02973-0321-4789-8c69-e20b9c90cb4f"]: LaborTemplates,
  ["d2ea1c95-5545-4b17-af8a-56bdf03052de"]: LaborTemplates,
  ["da91285f-c7d8-4202-89f9-70967b726907"]: LaborTemplates,

  ["5f96adcf-22f7-4d5d-916b-b1316ccbe9b7"]: ProjetoManejeBemTemplates,

  ["1540697b-397c-4a25-80eb-e957ef61b523"]: ProjetoSoy,

  ["332bdca8-6c13-4ae6-af99-8df8c4fc787d"]: ProjetoMSD,

  ["f96a6aee-f610-47c9-a2b1-0bcd3bd34b48"]: ProjetoCoopatec,
}

export const templateTermsList = (projectId) => termsList[projectId]
